export default __webpack_public_path__ + "static/media/external-link-mobile.589a74f1.svg";